import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, BankAccountTransferDialogueHandler } from './types';
import BankAccountTransferDialogueContext from './BankAccountTransferContext';

const { ConfirmationDialogue } = vp;

type BankAccountTransferDialogueProps = {
  handleDialogue: DialogueHandler<BankAccountTransferDialogueHandler>;
};

type FC = FunctionComponent<BankAccountTransferDialogueProps>;

const BankAccountTransferDialogue: FC = ({ handleDialogue }: BankAccountTransferDialogueProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.BankAccountTransfer.Dialogue' });
  const { showBankAccountTransferErrorAlert, bankAccountTransferError } = useContext(
    BankAccountTransferDialogueContext,
  );

  return useMemo(
    () => (
      <div>
        {/* EFT Fund Error */}
        <ConfirmationDialogue
          isVisible={showBankAccountTransferErrorAlert}
          title={t('errorTitle', { defaultValue: 'Error! The transaction was not completed.' })}
          status="error"
          subTitle={`${bankAccountTransferError}`}
          confirm={{
            label: t('back', { defaultValue: 'Back' }),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showBankAccountTransferErrorAlert, bankAccountTransferError],
  );
};

export default BankAccountTransferDialogue;
